import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=7c82e2b9&scoped=true&"
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=7c82e2b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82e2b9",
  null
  
)

export default component.exports